import type { RootState } from '/business/shared/state/store';

const countries = (state: RootState) => state.location?.countries;

export default countries;
